var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentGopay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 506.6 506.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00add5;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #010101;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Gopay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.29,0c139.9,0,253.29,113.39,253.29,253.29S393.19,506.51,253.29,506.51,0,393.12,0,253.29,113.39,0,253.29,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M400.82,245.35A58.81,58.81,0,0,0,339.41,190h-160a10.56,10.56,0,1,1,0-21.12H341.5a50.27,50.27,0,0,0-36.91-46.53,409.3,409.3,0,0,0-142.82,0,67.33,67.33,0,0,0-50.63,56.35,504.61,504.61,0,0,0,0,150A71.16,71.16,0,0,0,168.84,385a716.33,716.33,0,0,0,176.55,0,61.85,61.85,0,0,0,49-53.22,401,401,0,0,0,6.43-86.42m-52.56,35.48v9.42l-10.53,10.53a10.59,10.59,0,0,1-10.6-10.53v-9.42l-5.25-11.69a15.82,15.82,0,1,1,31.64,0l-5.26,11.69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentGopay);
export default __webpack_public_path__ + "static/media/payment_gopay.87bc9124e0d0a616b24ec170f7fa8df1.svg";
export { ForwardRef as ReactComponent };